import { Button } from '@/new/components/shadcn/button';
import { ButtonGroup } from '@/new/components/shadcn/button-group';

export function DatePresetOptions({
  setPresetRange,
}: {
  setPresetRange: (amount: moment.DurationInputArg1, unit: moment.DurationInputArg2) => void;
}) {
  return (
    <ButtonGroup>
      <Button onClick={() => setPresetRange(1, 'days')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        Last 24 hours
      </Button>
      <Button onClick={() => setPresetRange(1, 'weeks')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        Last 7 days
      </Button>
      <Button onClick={() => setPresetRange(2, 'weeks')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        2W
      </Button>
      <Button onClick={() => setPresetRange(1, 'months')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        1M
      </Button>
      <Button onClick={() => setPresetRange(3, 'months')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        3M
      </Button>
      <Button onClick={() => setPresetRange(1, 'years')} className="hover:border-gray-300 hover:bg-gray-200" size="sm">
        1Y
      </Button>
    </ButtonGroup>
  );
}
